import { Link } from "react-router-dom";
import { useAnnouncements } from "@/hooks/useAnnouncements";
import { useLanguage } from "@/contexts/LanguageContext";

export const AnnouncementBar = () => {
  const { announcements } = useAnnouncements();
  const { language } = useLanguage();

  const texts = announcements
    .map((a) => ({
      id: a.id,
      text:
        (language === "lv" ? a.text_lv : language === "ru" ? a.text_ru : a.text_en) ||
        a.text_en ||
        a.text_lv,
      link: a.link_url,
    }))
    .filter((a) => a.text && a.text.trim().length > 0);

  if (texts.length === 0) return null;

  // Repeat texts so one half is always wider than the widest screen (no empty gaps),
  // then duplicate that half so the -50% animation loops seamlessly.
  const totalChars = texts.reduce((sum, t) => sum + t.text.length + 6, 0);
  const repeats = Math.max(1, Math.ceil(400 / Math.max(totalChars, 1)));
  const half = Array.from({ length: repeats }, () => texts).flat();
  const loop = [...half, ...half];
  // Constant speed regardless of text length
  const duration = Math.max(20, (totalChars * repeats) / 6);

  return (
    <div className="w-full overflow-hidden bg-charcoal border-b border-copper/20">
      <div
        className="flex w-max animate-marquee hover:[animation-play-state:paused]"
        style={{ animationDuration: `${duration}s` }}
      >
        {loop.map((item, i) => (
          <div key={`${item.id}-${i}`} className="flex items-center whitespace-nowrap">
            <span className="mx-4 text-copper/60 select-none" aria-hidden="true">
              •
            </span>
            {item.link ? (
              item.link.startsWith("http") ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-2 text-[11px] uppercase tracking-[0.18em] text-cream/80 hover:text-copper transition-colors"
                >
                  {item.text}
                </a>
              ) : (
                <Link
                  to={item.link}
                  className="py-2 text-[11px] uppercase tracking-[0.18em] text-cream/80 hover:text-copper transition-colors"
                >
                  {item.text}
                </Link>
              )
            ) : (
              <span className="py-2 text-[11px] uppercase tracking-[0.18em] text-cream/80">
                {item.text}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
